export default {
  root: {
    "&$focused $notchedOutline": {
      borderColor: "white",
      borderWidth: 1,
    },
  },
};
